


























import {mixins} from "vue-class-component";
import {CommonMixin} from "../../../shared/services/mixin";
import {Component, Prop, PropSync} from "vue-property-decorator";
import {FormModel} from "ant-design-vue";
import {ComplaintCustomerStore} from "@/modules/complaintcustomer/store";

const form = {
    billLadingRowGuid: undefined,
    content: undefined
}
@Component({
    name: "ComplaintCustomerForm"
})
export default class extends mixins(CommonMixin) {
    @Prop() readonly billLadingRowGuid!: string;
    @PropSync("visibleForm", { type: Boolean, default: false }) syncVisibleForm!: boolean;
    isSubmitting = false;
    form = { ...form };
    rules = {
        content: [{ required: true, message: 'Nhập nội dung khiếu nại', trigger: 'change' }]
    }

    submit() {
        (this.$refs.complaintCustomerForm as FormModel).validate(async (valid) => {
            if (!valid) return;
            try {
                this.isSubmitting = true;
                await ComplaintCustomerStore.createComplaintCustomer({ ...this.form, billLadingRowGuid: this.billLadingRowGuid });
                this.$message.success("Khiếu nại thành công");
                this.syncVisibleForm = false;
            } catch (e) {
                this.$message.error(e?.response?.data?.message || "Đã xảy ra lỗi");
            } finally {
                this.isSubmitting = false;
            }
        })
    }
}
